<template>
  <v-card class="elevation-6">
    <v-card-text>
      <p class="mt-5 display-1 text-center">
        <v-img
          class="logo-iph-sys"
          src="../../assets/images/layout/logo-iph-sistemas-instituto-pro-hemoce.png"
        ></v-img>
      </p>
      <p class="text-center">Informe seus dados para acessar a área administrativa</p>
    </v-card-text>
    <v-card-text v-if="messageError" class="m-0 p-0">
      <v-alert dense text type="error" class="ma-0">
        <strong>Email</strong> ou <strong>Senha</strong> está <strong>inválido</strong>.
      </v-alert>
    </v-card-text>

    <v-card-text v-if="messageSuccess" class="m-0 p-0">
      <v-alert dense text type="success" class="ma-0">
        <strong> Redirecionando </strong>.
        <v-progress-linear indeterminate color="green"></v-progress-linear>
      </v-alert>
    </v-card-text>

    <v-card-text>
      <v-form>
        <v-text-field
          :disabled="progress || messageSuccess"
          dense
          solo
          v-model.trim="$v.form.email.$model"
          type="email"
          label="Digite seu email"
          prepend-icon="mdi-email"
          color="red"
        ></v-text-field>
        <v-text-field
          :disabled="progress || messageSuccess"
          dense
          solo
          v-model.trim="$v.form.password.$model"
          type="password"
          label="Digite seu senha"
          prepend-icon="mdi-lock"
          color="red"
        ></v-text-field>

        <v-btn
          v-if="!progress"
          block
          large
          class="mb-5 bbb"
          :disabled="$v.$invalid"
          color="bbbb btn-bg-red-1 l-text-white"
          @click="login"
        >
          Acessar
          <v-icon dark right>mdi-logout-variant</v-icon>
        </v-btn>

        <v-card-text class="m-0 p-0" align="center" v-else>
          <v-progress-circular :size="50" color="red" indeterminate> </v-progress-circular>
        </v-card-text>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'FormLogin',
  data: () => {
    return {
      progress: '',
      messageSuccess: '',
      messageError: '',
      form: {
        email: '',
        password: '',
      },
    }
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    },
  },
  created() {
    this.form.email = this.GET_email
    this.form.password = this.GET_password
    this.progress = this.GET_process
    this.messageSuccess = this.GET_successMessage
    this.messageError = this.GET_errorMessage
  },
  computed: {
    ...mapGetters('auth', [
      'GET_email',
      'GET_password',
      'GET_process',
      'GET_successMessage',
      'GET_errorMessage',
    ]),
  },
  watch: {
    GET_email: function () {
      this.form.email = this.GET_email
    },
    GET_password: function () {
      this.form.password = this.GET_password
    },
    GET_process: function () {
      this.progress = this.GET_process
    },
    GET_successMessage: function () {
      this.messageSuccess = this.GET_successMessage
    },
    GET_errorMessage: function () {
      this.messageError = this.GET_errorMessage
    },
  },
  methods: {
    ...mapActions('auth', ['ActionLogin']),
    login() {
      try {
        this.ActionLogin(this.form)
      } catch (error) {}
    },
  },
}
</script>
